import React from 'react';
import t from 'prop-types';

var EntradaTipoRepaso = function EntradaTipoRepaso(_ref) {
  var titulo = _ref.titulo,
      onClick = _ref.onClick;
  return React.createElement('div', {
    className: 'repasoIndice',
    onClick: onClick,
    dangerouslySetInnerHTML: {
      __html: titulo
    }
  });
};

EntradaTipoRepaso.propTypes = process.env.NODE_ENV !== "production" ? {
  titulo: t.string,
  onClick: t.func
} : {};
export default EntradaTipoRepaso;